import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getLatestAiSystemInstructions = async () => {
    const { data } = await vlqrApi.get('aiSystemInstructions/allLatest')
        .catch((error) => {
            handleError(error);
        });
    return data;
};

const useLatestAiSystemInstructions = () => {
    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: ['latestAiSystemInstructions'],
        queryFn: getLatestAiSystemInstructions
    });

    return { data, refetch, isLoading, isError };
};

export default useLatestAiSystemInstructions;
